"use strict";
/* Copyright (c) 2020 Ezzat Chamudi
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJapanese = exports.isCJK = exports.isKana = exports.isWithinRanges = void 0;
const ranges_1 = require("./ranges");
function isWithinRanges(string, rangesCollection) {
    const cpArray = [...string].map((char) => {
        const cp = char.codePointAt(0);
        if (cp === undefined)
            throw new Error();
        return cp;
    });
    return cpArray.every((cp) => 
    // eslint-disable-next-line implicit-arrow-linebreak
    rangesCollection.some((ranges) => 
    // eslint-disable-next-line implicit-arrow-linebreak
    ranges.some((range) => range[0] <= cp && cp <= range[1])));
}
exports.isWithinRanges = isWithinRanges;
function isKana(string) {
    return isWithinRanges(string, [ranges_1.KanaRanges]);
}
exports.isKana = isKana;
function isCJK(string) {
    return isWithinRanges(string, [ranges_1.CJKranges]);
}
exports.isCJK = isCJK;
function isJapanese(string) {
    return isWithinRanges(string, [ranges_1.KanaRanges, ranges_1.CJKranges]);
}
exports.isJapanese = isJapanese;
